"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  anchor: {},
  toggle: {
    display: 'flex',
    flexGrow: 1
  },
  dropdown: {
    overflow: 'auto'
  }
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-web/components/form/Dropdown/styles.js
// module id = ./node_modules/quark-web/components/form/Dropdown/styles.js
// module chunks = 0